<template>
  <page-outline :title="pageTitle">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="pageContent">
      <b-container fluid>
        <spinner v-if="activateSpinner"></spinner>
        <vop-provider-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></vop-provider-form>
      </b-container>
    </template>
    <template slot="bottomActions">
      <app-button
        v-if="isEditable && formType !== 'add'"
        :text="$t('common.cncl')"
        variant="secondary"
        custom-class="mr-3"
        @click="switchMode('details')">
      </app-button>
      <app-button
        v-if="!isEditable && formType !== 'add'"
        :text="$t('administration.edit')"
        icon="fa-light fa-pencil"
        variant="primary"
        custom-class="mr-3"
        @click="switchMode('edit')">
      </app-button>
      <app-button
        v-if="!isEditable && formType !== 'add'"
        :text="$t('rights.delete')"
        icon="fa-light fa-trash"
        variant="danger"
        @click="deleteVopProvider">
      </app-button>
      <app-button
        v-if="isEditable && formType !== 'add'"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="editVopProvider">
      </app-button>
      <app-button
        v-if="mode === 'add'"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="addVopProvider">
      </app-button>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'
import VopProviderForm from '@/pages/vopProvider/VopProviderForm.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "VopProviderDetails",
  components: {
    'app-button': AppButton,
    'vop-provider-form': VopProviderForm,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.vop_provider_edit')
        case 'details':
          return this.$t('Webheader.vop_provider_details')
        case 'add':
        default:
          return this.$t('Webheader.vop_provider_add')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      vopProvider: '',
      returnUrl: '',
      currentVopProvider: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = '/vopProvider/'

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getVopProvider()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addVopProvider () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        NameVopProvider: this.config.NameVopProvider,
        IdVopProvider: this.IdVopProvider
      }
      this.$engine.firstOn().vopProvider.addVopProvider(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.vop_provider.vop_provider_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/vopProvider/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid NameVopProvider") {
              that.okMessageBox(that.$t('common.vop_provider.name_exist_db'))
            }
          })
        } else {
          errorMessageAlert(e, that)
        }
      })
    },
    deleteVopProvider () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.vop_provider.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdVopProvider: that.id
              }
              that.$engine.firstOn().vopProvider.deleteVopProvider(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.vop_provider.vop_provider_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: '/vopProvider/'})
              })
              .catch((e) => {
                if (e.response.status === 400 && e.response.data.errors) {
                  const errors = e.response.data.errors

                  errors.forEach((error) => {
                    if (error.error === "Deletion Error") {
                      that.okMessageBox(that.$t('common.vop_provider.unable_del'))
                    }
                  })
                } else {
                  errorMessageAlert(e, that, that.$i18n)
                  that.okMessageBox(that.$t('common.vop_provider.vop_provider_delete_error'))
                }
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editVopProvider () {

      if (this.formHasError()) {
        return
      }

      let that = this
      let params = {
        IdVopProvider: this.id,
        NameVopProvider: this.config.NameVopProvider
      }
      this.$engine.firstOn().vopProvider.editVopProvider(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.vop_provider.vop_provider_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/vopProvider/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid NameVopProvider") {
              that.okMessageBox(that.$t('common.vop_provider.name_exist_db'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    fillFields () {
      this.config = this.currentVopProvider
      this.originalConfig = this.currentVopProvider
      this.activateSpinner = false
    },
    formHasError () {
      if (this.config.NameVopProvider === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.vop_provider.name_missing'))
        return true
      }
      return false
    },
    getVopProvider () {
      this.$engine.firstOn().vopProvider.getVopProvider({})
      .then(resp => {
        let that = this
        let vopProviderList = {}

        vopProviderList = resp.data.VopProvider

        that.updateVopProvider(vopProviderList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateVopProvider(vopProviderList){
      const selectedVopProvider = vopProviderList.find(vopProvider => vopProvider.IdVopProvider === this.id)
      this.currentVopProvider = selectedVopProvider
      this.fillFields()
    },
    goBack () {
      loadPage(this, {url: this.returnUrl})
    }
  }
}
</script>
